// extracted by mini-css-extract-plugin
export default {"item_title":"SearchResultItem_item_title__7wENA"};